// extracted by mini-css-extract-plugin
module.exports = {"lossCauseRadioButton":"WhatPage_lossCauseRadioButton__3Q3cN"};